import { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import {
  HiDocumentPlus,
  HiDocumentText,
  HiGlobeAlt,
  HiScale,
  HiBuildingLibrary,
  HiBanknotes,
  HiPaperAirplane,
  HiInboxArrowDown,
  HiCalendarDays,
  HiFlag,
  HiPlus,
} from "react-icons/hi2";

import adminUi from "../UI/AdminUi.module.css";
import { alertActions } from "../../store/alert-slice";
import Spinner from "../UI/Spinner";
import { createTransaction } from "../../api/api";
import { getAuthToken } from "../../util/authToken";

const CreateTransaction = () => {
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useDispatch();
  const modeRef = useRef();
  const destinationRef = useRef();
  const amountRef = useRef();
  const senderRef = useRef();
  const receipientRef = useRef();
  const dateRef = useRef();
  const statusRef = useRef();
  const typeRef = useRef();

  const submitHandler = async (e) => {
    e.preventDefault();
    setShowSpinner(true);

    const data = {
      kind: modeRef.current.value,
      type: typeRef.current.value,
      bankName: destinationRef.current.value,
      amount: amountRef.current.value,
      sender: senderRef.current.value,
      receipient: receipientRef.current.value,
      createdAt: dateRef.current.value,
      status: statusRef.current.value,
    };

    const res = await createTransaction(getAuthToken(), data);

    if (res.status === "success") {
      dispatch(
        alertActions.setState({ message: res.message, status: res.status })
      );
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }

    setShowSpinner(false);
  };

  return (
    <div className={adminUi.page}>
      <h1 className={adminUi.pageTitle}>
        <HiDocumentPlus className={adminUi.pageTitleIcon} aria-hidden />
        Create transaction
      </h1>
      <p className={adminUi.pageLead}>
        Post manual or corrective transfers with full routing metadata.
      </p>
      <motion.form
        className={adminUi.formCard}
        onSubmit={submitHandler}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
      >
        {showSpinner && <Spinner />}
        <h2 className={adminUi.formTitle}>
          <HiDocumentText className={adminUi.formTitleIcon} aria-hidden />
          Transaction details
        </h2>
        <div className={adminUi.field}>
          <label htmlFor="tx-mode">Channel</label>
          <div className={adminUi.selectWrap}>
            <HiGlobeAlt className={adminUi.fieldIcon} aria-hidden />
            <select id="tx-mode" ref={modeRef} defaultValue="">
              <option value="" disabled>
                Choose
              </option>
              <option>International</option>
              <option>Domestic</option>
              <option>In-person</option>
            </select>
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="tx-type">Debit / credit</label>
          <div className={adminUi.selectWrap}>
            <HiScale className={adminUi.fieldIcon} aria-hidden />
            <select id="tx-type" ref={typeRef} defaultValue="">
              <option value="" disabled>
                Choose
              </option>
              <option>debit</option>
              <option>credit</option>
            </select>
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="tx-destination">
            Destination bank (leave empty for in-person)
          </label>
          <div className={adminUi.inputWrap}>
            <HiBuildingLibrary className={adminUi.fieldIcon} aria-hidden />
            <input id="tx-destination" type="text" ref={destinationRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="tx-amount">Amount</label>
          <div className={adminUi.inputWrap}>
            <HiBanknotes className={adminUi.fieldIcon} aria-hidden />
            <input id="tx-amount" type="number" ref={amountRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="tx-sender">Sender account number</label>
          <div className={adminUi.inputWrap}>
            <HiPaperAirplane className={adminUi.fieldIcon} aria-hidden />
            <input id="tx-sender" type="text" ref={senderRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="tx-recipient">
            Recipient account (empty for in-person)
          </label>
          <div className={adminUi.inputWrap}>
            <HiInboxArrowDown className={adminUi.fieldIcon} aria-hidden />
            <input id="tx-recipient" type="text" ref={receipientRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="tx-date">Date</label>
          <div className={adminUi.inputWrap}>
            <HiCalendarDays className={adminUi.fieldIcon} aria-hidden />
            <input id="tx-date" type="datetime-local" ref={dateRef} />
          </div>
        </div>
        <div className={adminUi.field}>
          <label htmlFor="tx-progress">Progress</label>
          <div className={adminUi.selectWrap}>
            <HiFlag className={adminUi.fieldIcon} aria-hidden />
            <select id="tx-progress" ref={statusRef} defaultValue="">
              <option value="" disabled>
                Choose
              </option>
              <option>true</option>
              <option>false</option>
            </select>
          </div>
        </div>
        <div className={adminUi.actions}>
          <button className={adminUi.btnPrimary} type="submit">
            <HiPlus className={adminUi.btnPrimaryIcon} aria-hidden />
            Create transaction
          </button>
        </div>
      </motion.form>
    </div>
  );
};

export default CreateTransaction;
